import * as React from "react";
import {inject, observer} from "mobx-react";

import {ButtonInline} from "@ok/common/design-system/components/ButtonInline";
import {ClipsFullscreenStore} from "../../../../lib/ClipsFullscreenStore";
import {Clip, Direction, ToastType} from "../../../../lib/types";
import {AnonymControlWrapper} from "../../common/controls/AnonymControlWrapper";
import {DataL} from "@ok/web/utils/DataL";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

interface IDislike {
    bean: Clip;
    store?: ClipsFullscreenStore
}

export const Dislike: React.FC<IDislike> = inject("store")(observer(
    (props: IDislike): React.ReactElement => {
        const store = props.store!;
        const authorInfo = props.bean.payload.authorInfo;
        const clipId = props.bean.meta.movie.id;

        const [isDisliked, setIsDisliked] = React.useState(false);


        const handleClick = () => {
            if (store.isAnonym) {
                return;
            }

            if (isDisliked) {
                store.abortDeletion();
                setIsDisliked(false);
            } else {
                store.setIndexToDelete();
                setIsDisliked(true);

                /*
                * При множественных дизлайках, сначала просиходит удаление клипа, затем перемещение
                * */
                setTimeout(() => {
                    store.setShowToast(ToastType.DISLIKED);
                    store.setScroll(Direction.FORWARD);
                    store.setIsAnimationRunning(true);
                    store.setOffset();
                }, 50);
            }
        };

        // Обрабатываем переход к следующему/предыдущему клипу
        React.useEffect(() => {
            const {movieId: currentMovie} = props.bean.meta.movie;
            const {movieId: deletedMovie} = store.rawFullscreenItems[store.indexToDelete]?.meta.movie ?? {};
            setIsDisliked(currentMovie === deletedMovie);
        }, [props.bean.meta.movie, store.indexToDelete, store.rawFullscreenItems]);

        const logAttr = DataL.attr({
            target: "VK_CLIPS_LIST_DISLIKE",
            clipId: clipId,
            ownerId: authorInfo.id,
            position: store.currentItemIndex
        });

        return (
            <AnonymControlWrapper>
                <ButtonInline
                    data-tsid={" "}
                    size={"32"}
                    view={"primary-on-color"}
                    aria-label={l10NPkg.getLMsg("setDislikeOnClip")}
                    onClick={handleClick}
                    {...logAttr}
                >
                    <ButtonInline.LeftIcon
                        icon={isDisliked ? "glyph_dislike_filled_24+" : "glyph_dislike_24+"}
                    />
                </ButtonInline>
            </AnonymControlWrapper>
        );
    }
));
